var _path, _path2, _g, _rect, _path3, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.4217V0.406738L11.591 12.0257H4.55L4.399 12.1497L0 16.4217Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.81396V14.002L3.969 11.136L4.129 10.997H9.165L1 2.81396Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_1813_2340)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.894,
    cy: 20.9439,
    rx: 1.89403,
    ry: 1.16556,
    fill: "#555454"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.416,
    y: 8,
    width: 1.02083,
    height: 12.4541,
    rx: 0.306249,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5625 11.2155L16.2844 13.8235V8.60756L22.5625 11.2155Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9548,
    cy: 20.4538,
    r: 1.4099,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1813_2340",
    x: 11.9603,
    y: 17.7386,
    width: 7.86656,
    height: 6.41051,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.01986,
    result: "effect1_foregroundBlur_1813_2340"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorGreen);
export default __webpack_public_path__ + "static/media/cursor-green.808c1c45d6e87551fc88eca6bd4d2eab.svg";
export { ForwardRef as ReactComponent };